<div *ngIf="!p.renderMobile" class="breadcrumb-margin margin-bottom-3">
  <app-breadcrumb></app-breadcrumb>
</div>

<ng-container *ngIf="!isError; else HTTPError">
  <ion-grid
    [ngClass]="{ 'height-0': !placeDetailsLoaded && !placeAssignmentsLoaded }"
  >
    <ion-row class="margin-minus-20-mobile">
      <ion-col
        [attr.offset-xl]="spaceId ? '' : '3'"
        [attr.size-xl]="spaceId ? '5' : '6'"
        size="12"
      >
        <app-card [title]="headerInit.title">
          <form class="w-100" [formGroup]="form" (ngSubmit)="onSaveSpace()">
            <app-input
              type="input"
              [form]="form"
              formControlName="number"
              label="NUMBER"
              [submittedError]="validationError"
              [disabled]="!isDisabled"
            ></app-input>

            <app-input
              type="input"
              [form]="form"
              formControlName="shortName"
              label="SPACE.SHORT_NAME"
              [submittedError]="validationError"
              [disabled]="!isDisabled"
            ></app-input>

            <div
              class="control-display"
              *ngIf="dictionaryServ.parkingSubtype && showSpaceSubtypePicker"
            >
              <ion-label color="dark">{{
                'SPACE.PARKING.PLACE_TYPE' | translate
              }}</ion-label>
              <app-select-dropdown
                formControlName="subtype"
                displayKey="key"
                [data]="dictionaryServ.parkingSubtype"
                [isDisabled]="!isDisabled"
              ></app-select-dropdown>
            </div>

            <div
              *ngIf="!hideBuildingDropdown"
              class="control-display"
              [ngClass]="{
                'control-display--invalid':
                  form.get('building').hasError('required') &&
                  (form.get('building').touched || validationError)
              }"
            >
              <ion-label color="dark"
                >{{ 'SPACE.BUILDING' | translate }}*
              </ion-label>
              <app-select-dropdown
                formControlName="building"
                [data]="buildingServ.buildings"
                [value]="initialBuilding"
                (changeValueEvent)="onBuildingChange($event)"
                (touchEvent)="onSelectTouched('building')"
                [isDisabled]="!isDisabled"
              ></app-select-dropdown>
            </div>
            <ion-label
              *ngIf="
                form.get('building').hasError('required') &&
                (form.get('building').touched || validationError)
              "
              color="danger"
              class="font-size__16"
            >
              {{ 'SPACE.REQUIRED_VALIDATION' | translate }}
            </ion-label>

            <div
              class="control-display"
              [ngClass]="{
                'control-display--invalid':
                  (form.get('floor').hasError('required') &&
                    (form.get('floor').touched || validationError)) ||
                  floorDoesntExist
              }"
            >
              <ion-label color="dark"
                >{{ 'SPACE.FLOOR' | translate }}*</ion-label
              >
              <app-select-dropdown
                #floorDropdown
                [ngClass]="floorListDisabled ? 'display-none' : ''"
                [data]="floorList"
                [value]="form.controls.floor.value"
                (changeValueEvent)="onFloorChange($event)"
                (touchEvent)="onSelectTouched('floor')"
                [isDisabled]="!isDisabled"
              ></app-select-dropdown>
              <app-select-dropdown
                [ngClass]="floorListDisabled ? '' : 'display-none'"
                [placeholder]="'SPACE.NO_FLOOR'"
                [isDisabled]="true"
              ></app-select-dropdown>
            </div>

            <ion-label
              *ngIf="
                form.get('floor').hasError('required') &&
                (form.get('floor').touched || validationError)
              "
              color="danger"
              class="font-size__16"
            >
              {{ 'SPACE.REQUIRED_VALIDATION' | translate }}
            </ion-label>

            <ion-label *ngIf="floorDoesntExist" color="danger" class="font-size__16">
              {{ 'FLOOR_MISSING' | translate }}
            </ion-label>
            <ng-container *ngIf="showTimePicker">
              <ion-item class="input" lines="none">
                <div
                  class="control-display"
                  [ngClass]="{
                    'control-display--invalid':
                      (form.get('timeFrom').hasError('required') ||
                        form.hasError('startTimeBigger') ||
                        form.get('timeFrom').hasError('onlySpaces')) &&
                      (form.get('timeFrom').touched ||
                        timeError ||
                        validationError)
                  }"
                >
                  <ion-label
                    >{{ 'SPACE.ROOM.TIME_FROM' | translate }}*</ion-label
                  >

                  <app-date-time-picker
                    pickerType="timer"
                    placeholder="{{ 'ADD_INVITATION.SELECT_TIME' | translate }}"
                    [value]="timeFrom"
                    [timerMax]="timeMax"
                    (afterPickerClosed)="onTimeSelected($event, 'start')"
                  ></app-date-time-picker>
                </div>
              </ion-item>

              <ion-label
                *ngIf="
                  (form.get('timeFrom').hasError('required') ||
                    form.get('timeFrom').hasError('onlySpaces')) &&
                  validationError
                "
                color="danger"
                class="font-size__16"
              >
                {{ 'SPACE.ROOM.REQUIRED_VALIDATION' | translate }}
              </ion-label>

              <ion-item class="input" lines="none" *ngIf="showTimePicker">
                <div
                  class="control-display"
                  [ngClass]="{
                    'control-display--invalid':
                      (form.get('timeTo').hasError('required') ||
                        form.hasError('startTimeBigger')) &&
                      (validationError ||
                        form.get('timeTo').hasError('onlySpaces') ||
                        timeError)
                  }"
                >
                  <ion-label>{{ 'SPACE.ROOM.TIME_TO' | translate }}*</ion-label>
                  <app-date-time-picker
                    pickerType="timer"
                    placeholder="{{ 'ADD_INVITATION.SELECT_TIME' | translate }}"
                    [value]="timeTo"
                    [timerMin]="timeMin"
                    (afterPickerClosed)="onTimeSelected($event, 'end')"
                  ></app-date-time-picker>
                </div>
              </ion-item>
              <ion-label
                *ngIf="
                  (form.get('timeTo').hasError('required') ||
                    form.get('timeTo').hasError('onlySpaces')) &&
                  (form.get('timeTo').touched || validationError)
                "
                color="danger"
                class="font-size__16"
              >
                {{ 'SPACE.ROOM.REQUIRED_VALIDATION' | translate }}
              </ion-label>
              <ion-label
                *ngIf="
                  form.hasError('startTimeBigger') &&
                  (form.get('timeTo').touched ||
                    form.get('timeFrom').touched ||
                    timeError ||
                    validationError)
                "
                color="danger"
                class="font-size__16"
              >
                {{ 'SPACE.ROOM.TIME_ERROR' | translate }}
              </ion-label>
            </ng-container>

            <app-input
              *ngIf="showSpaceCapacity"
              type="number"
              [form]="form"
              formControlName="capacity"
              label="SPACE.ROOM.MAX_CAPACITY"
              [submittedError]="validationError"
              [customErrors]="[{
                message: 'SPACE.ROOM.CAPACITY_VALIDATION',
                code: 'min'
              }]"
            ></app-input>

            <app-input
              type="textarea"
              [form]="form"
              formControlName="description"
              label="SPACE.ADDITIONAL_DESCRIPTION"
              [submittedError]="validationError"
              [disabled]="!isDisabled"
            ></app-input>

            <app-checkbox
              *ngIf="spaceType === spaceTypeEnum.Parking"
              [slot]="'start'"
              [form]="form"
              formControlName="isAutomaticShare"
              [checked]="form.controls.isAutomaticShare.value"
              label="SPACE.AUTOMATIC_SHARE"
              [disabled]="!isDisabled"
            ></app-checkbox>

            <app-checkbox
              *ngIf="spaceType === spaceTypeEnum.Room"
              [slot]="'start'"
              [form]="form"
              formControlName="isAvailableAtWeekends"
              [checked]="form.controls.isAvailableAtWeekends.value ? true : false"
              label="SPACE.AVAILABLE_AT_WEEKENDS"
              [disabled]="!isDisabled"
            ></app-checkbox>

            <!-- forGuest -->

            <app-assign-equipment
              [equipmentList]="spaceServ.equipmentList"
              [spaceType]="spaceType"
            ></app-assign-equipment>

            <app-upload-attachment 
              *ngIf="isDisabled"
              [attachment]="attachment"
            ></app-upload-attachment>
            
            <ion-label
              *ngIf="
                form.get('itemImage').hasError('fileMaxSize') &&
                (form.get('itemImage').touched || validationError)
              "
              color="danger"
              class="font-size__16"
            >
              <div>{{ 'SPACE.MAX_SIZE_VALIDATION' | translate }}</div>
            </ion-label>

            <ion-label
              *ngIf="form.get('itemImage').hasError('fileFormat')"
              color="danger"
              class="font-size__16"
            >
              <div>
                {{ 'FILE_TYPE_VALIDATION_1' | translate }}
                "{{ form.get('itemImage').errors.fileFormat.actualFormat }}".
                {{ 'FILE_TYPE_VALIDATION_2' | translate }}
              </div>
            </ion-label>
            <div
              *ngIf="placeDetailsLoaded && placeAssignmentsLoaded"
              [ngClass]="
                p.renderMobile
                  ? 'flex-justify-content-flex-end'
                  : 'display-flex space-between'
              "
            >
              <ng-container *ngIf="!p.renderMobile">
                <ng-container *appHasRole="[permissionSpaceEdit]">
                  <ion-button
                    fill="outline"
                    color="primary"
                    (click)="deleteParkingPlace()"
                    *ngIf="spaceId"
                  >
                    {{ 'DELETE' | translate }}
                  </ion-button>
                </ng-container>
              </ng-container>

              <div
                [ngClass]="{ 'space-edit__buttons-container': !p.renderMobile }"
              >
                <ion-button
                  *ngIf="!p.renderMobile"
                  fill="solid"
                  color="secondary"
                  (click)="backToPakingList()"
                >
                  {{ 'CANCEL' | translate }}
                </ion-button>

                <ion-button
                  type="submit"
                  *appHasRole="[permissionSpaceEdit]"
                  [disabled]="disableSaveButton"
                >
                  <ng-container *ngIf="!disableSaveButton">{{
                    'SAVE' | translate
                  }}</ng-container>
                  <ng-container *ngIf="disableSaveButton">{{
                    'SAVING' | translate
                  }}</ng-container>
                </ion-button>
              </div>
            </div>
          </form>
        </app-card>
      </ion-col>

      <ion-col size-xl="7" size="12" *ngIf="spaceId">
        <app-card
          title="{{ 'SPACE.ASSIGN_COMPANY_OR_PERSON' | translate }}"
          hideHeaderBreakpoint="300"
        >
          <app-pagination-client-side
            [componentRef]="componentRef"
            [columns]="columnsDefinition"
            [options]="options"
            (rowsLoaderReady)="rowsLoaderServiceReady($event)"
            (actionRequest)="onActionRequest($event)"
            (headerEmitClick)="addAssignment()"
            (refreshRequest)="loadSpaceAssignments()"
          >
          </app-pagination-client-side>
        </app-card>
      </ion-col>
    </ion-row>
  </ion-grid>
</ng-container>
<ng-template #HTTPError>
  <app-api-not-found
    name="SPACE.PARKING.CAR_SPACE"
    returnText="SPACE.PARKING.RETURN_TO_PARKING_SPACES"
    link="app/parking?section=parking_space"
    [status]="errorStatus"
  >
  </app-api-not-found>
</ng-template>

<div class="spin" *ngIf="!placeDetailsLoaded && !placeAssignmentsLoaded">
  <app-loading-sti></app-loading-sti>
</div>
